import { call, put, select, takeLatest } from 'redux-saga/effects';

// Services
import { reportsApi } from 'services/apiDigitalTicket/reports';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';
import * as reportsActions from './actions';

// Types
import { ReportsTypes } from './types';

// Constants
import { REPORTS_TYPES } from 'constants/report';
import { errorMessagersList } from 'helpers/errorMessagers';

function* chartValueReport({
  payload,
}: ReturnType<typeof reportsActions.getChartReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados para o gráfico',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.chartValueReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getChartReportSuccess({
          chartReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - chartValueReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getChartReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* invoicesList({
  payload,
}: ReturnType<typeof reportsActions.getInvoicesListRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados',
      }),
    );
    const { body } = payload;

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.invoicesList, {
      params: { transportOperatorId: transportOperator.id, ...body },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getInvoicesListSuccess({
          invoicesList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - InvoicesList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getInvoicesListFailure());
    yield put(DialogsActions.setClose());
  }
}

function* invoicesListFull({
  payload,
}: ReturnType<typeof reportsActions.listInvoicesListRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados',
      }),
    );
    const { body, isCsvFull } = payload;

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.invoicesList, {
      params: { transportOperatorId: transportOperator.id, ...body },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getInvoicesListSuccess({
          isCsvFull,
          invoicesList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - InvoicesList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getInvoicesListFailure());
    yield put(DialogsActions.setClose());
  }
}

function* lineDemandReport({
  payload,
}: ReturnType<typeof reportsActions.lineDemandReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(
      payload['segment' as keyof typeof payload]
        ? reportsApi.segmentDemandReport
        : reportsApi.lineDemandReport,
      {
        params: { transportOperatorId: transportOperator.id, ...payload },
      },
    );

    if (response.status === 200) {
      yield put(
        reportsActions.lineDemandReportSuccess({
          lineDemandReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - LineDemandReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.lineDemandReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* lineQuantityReport({
  payload,
}: ReturnType<typeof reportsActions.lineQuantityReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(
      payload['segment' as keyof typeof payload]
        ? reportsApi.segmentDemandReport
        : reportsApi.lineQuantityReport,
      {
        params: { transportOperatorId: transportOperator.id, ...payload },
      },
    );

    if (response.status === 200) {
      yield put(
        reportsActions.lineQuantityReportSuccess({
          lineQuantityReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - lineQuantityReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.lineQuantityReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* kmPerDayReport({
  payload,
}: ReturnType<typeof reportsActions.kmPerDayReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.kmByDayReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.kmPerDayReportSuccess({
          kmByDayReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - kmPerDayReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.kmPerDayReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getPassengersAndVehicles({
  payload,
}: ReturnType<typeof reportsActions.getPassengersAndVehiclesRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.getPassengersAndVehicles, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getPassengersAndVehiclesSuccess({
          passengersAndVehiclesReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - kmPerDayReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getPassengersAndVehiclesFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getPassengersAndVehiclesByTrip({
  payload,
}: ReturnType<
  typeof reportsActions.getPassengersAndVehiclesByTripRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.getPassengersAndVehiclesByTrip, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getPassengersAndVehiclesByTripSuccess({
          passengersAndVehiclesByTripReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - kmPerDayReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getPassengersAndVehiclesByTripFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getTimedOutEntries({
  payload,
}: ReturnType<typeof reportsActions.getTimedOutEntriesRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.getTimedOutEntries, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getTimedOutEntriesSuccess({
          timedOutEntriesList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - timedOutEntries - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getTimedOutEntriesFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getPedestrianEntryByTerminal({
  payload,
}: ReturnType<typeof reportsActions.getPedestrianEntryByTerminalRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.getPedestrianEntryByTerminal, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getPedestrianEntryByTerminalSuccess({
          pedestriansEntryByTerminalList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - kmPerDayReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getPedestrianEntryByTerminalFailure());
    yield put(DialogsActions.setClose());
  }
}

function* dailyDemandReport({
  payload,
}: ReturnType<typeof reportsActions.dailyDemandReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.dailyDemandReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.dailyDemandReportSuccess({
          dailyDemandReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - LineDemandReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.dailyDemandReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* transportedPassengersByTimeFrame({
  payload,
}: ReturnType<
  typeof reportsActions.transportedPassengersByTimeFrameReportRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.chartEntryReportSimplified, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.transportedPassengersByTimeFrameReportSuccess({
          transportedPassengersByTimeFrameList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - transportedPassengersByTimeFrame - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.transportedPassengersByTimeFrameReportailure());
    yield put(DialogsActions.setClose());
  }
}

function* transportedPassengersByTimeFrameByProfile({
  payload,
}: ReturnType<
  typeof reportsActions.transportedPassengersByTimeFrameByProfileReportRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(
      reportsApi.transportedPassengersByTimeFrameByProfile,
      {
        params: { transportOperatorId: transportOperator.id, ...payload },
      },
    );

    if (response.status === 200) {
      yield put(
        reportsActions.transportedPassengersByTimeFrameByProfileReportSuccess({
          transportedPassengersByTimeFrameByProfileList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error(
      'reports - transportedPassengersByTimeFrameByProfile - error',
      error,
    );
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(
      reportsActions.transportedPassengersByTimeFrameByProfileReportailure(),
    );
    yield put(DialogsActions.setClose());
  }
}

function* dailyQuantityReport({
  payload,
}: ReturnType<typeof reportsActions.dailyQuantityReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.dailyQuantityReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.dailyQuantityReportSuccess({
          dailyQuantityReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - LineDemandReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.dailyQuantityReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* dailyQuantitySeccionedReport({
  payload,
}: ReturnType<typeof reportsActions.dailyQuantitySeccionedReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.dailyQuantitySeccionedReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.dailyQuantitySeccionedReportSuccess({
          dailyQuantitySeccionedReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - LineDemandReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.dailyQuantitySeccionedReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* chartEntryReport({
  payload,
}: ReturnType<typeof reportsActions.getChartEntryReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados para a tabela',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.chartEntryReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getChartEntryReportSuccess({
          chartEntryReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - chartEntryReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getChartEntryReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* chartEntryReportSimplified({
  payload,
  meta,
}: ReturnType<
  typeof reportsActions.getChartEntryReportSimplifiedRequest
>): any {
  const { isHistoryDatails } = payload;

  try {
    if (!isHistoryDatails) {
      yield put(
        DialogsActions.setOpenLoading({
          title: 'Carregando dados para a tabela',
        }),
      );
    }

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.chartEntryReportSimplified, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getChartEntryReportSimplifiedSuccess({
          chartEntryReportSimplifiedList: response.data,
        }),
      );

      meta.promise.resolve(response);
      if (!isHistoryDatails) yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - chartEntryReportSimplified - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getChartEntryReportSimplifiedFailure());
    yield put(DialogsActions.setClose());
  }
}

function* entryReportGrouped({
  payload,
}: ReturnType<typeof reportsActions.entryReportGroupedRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Agrupando dados para a tabela',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.chartEntryReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      if (Array.isArray(response.data)) {
        yield put(
          reportsActions.entryReportGroupedSuccess({
            entryReportListGrouped: response.data,
          }),
        );
      }

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - entryReportGrouped - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.entryReportGroupedFailure());
    yield put(DialogsActions.setClose());
  }
}

function* superiorAccessReport({
  payload,
}: ReturnType<typeof reportsActions.getSuperiorAccessReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados para a tabela',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.chartEntryReportSimplified, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getSuperiorAccessReportSuccess({
          superiorAccessReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - superiorAccessReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getSuperiorAccessReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* heatMapReport({
  payload,
}: ReturnType<typeof reportsActions.getHeatmapReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados para o gráfico',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.heatmapReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getHeatmapReportSuccess({
          heatmapList: response.data.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - heatMapReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getHeatmapReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* paymentReport({
  payload,
}: ReturnType<typeof reportsActions.paymentReportRequest>): any {
  try {
    const { isHistoryDatails } = payload;

    if (!isHistoryDatails) {
      yield put(
        DialogsActions.setOpenLoading({
          title: 'Carregando extrato',
        }),
      );
    }
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.paymentReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.paymentReportSuccess({
          paymentList: response.data,
        }),
      );

      if (!isHistoryDatails) yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - extractReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.paymentReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* EMTUReport({
  payload,
}: ReturnType<typeof reportsActions.emtuReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando relatório',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.emtuReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.emtuReportSuccess({
          emtuReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emtuReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.emtuReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* generalReport({
  payload,
}: ReturnType<typeof reportsActions.generalReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando relatório',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.generalReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.generalReportSuccess({
          generalReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - general report - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.generalReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* travelByLineReport({
  payload,
}: ReturnType<typeof reportsActions.travelByLineReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando relatório...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.travelByLineReport, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.travelByLineReportSuccess({
          travelByLineReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - travel by line report - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.travelByLineReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* scheduleList({
  payload,
}: ReturnType<typeof reportsActions.scheduleListRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando Lista',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.getScheduleList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      if (!payload.id) {
        yield put(
          reportsActions.scheduleListSuccess({
            scheduleList: response.data,
          }),
        );
      } else {
        yield put(
          reportsActions.scheduleSuccess({
            scheduleData: response.data,
          }),
        );
      }

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - scheduleList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.scheduleListFailure());
    yield put(DialogsActions.setClose());
  }
}

function* secondScheduleList({
  payload,
}: ReturnType<typeof reportsActions.secondScheduleListRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando Lista',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.getScheduleList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.secondScheduleListSuccess({
          secondScheduleList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - scheduleList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.secondScheduleListFailure());
    yield put(DialogsActions.setClose());
  }
}

function* scheduleDelete({
  payload,
}: ReturnType<typeof reportsActions.scheduleDeleteRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando Lista',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.scheduleDelete, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      if (Array.isArray(response.data)) {
        yield put(
          reportsActions.scheduleDeleteSuccess({
            scheduleDelete: response.data,
          }),
        );
      }

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - scheduleDelete - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.scheduleDeleteFailure());
    yield put(DialogsActions.setClose());
  }
}

function* scheduleCreate({
  payload,
}: ReturnType<typeof reportsActions.scheduleCreateRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Criando Agendamento' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.scheduleCreate, {
      data: {
        transportOperatorId: transportOperator.id,
        ...payload,
      },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.scheduleCreateSuccess({
          scheduleData: response.data,
        }),
      );

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Criado agendamento com sucesso',
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('lines - scheduleCreate - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.scheduleCreateFailure());
    yield put(DialogsActions.setClose());
  }
}
function* scheduleUpdate({
  payload,
}: ReturnType<typeof reportsActions.scheduleUpdateRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Criando Agendamento' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.scheduleUpdate, {
      data: {
        transportOperatorId: transportOperator.id,
        ...payload,
      },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.scheduleUpdateSuccess({
          scheduleData: response.data,
        }),
      );

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Editado agendamento com sucesso',
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('lines - scheduleUpdate - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.scheduleUpdateFailure());
    yield put(DialogsActions.setClose());
  }
}
function* paymentRequestList({
  payload,
}: ReturnType<typeof reportsActions.paymentRequestListRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando Lista',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.getPaymentRequestList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.paymentRequestListSuccess({
          paymentRequestList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - paymentRequestList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.paymentRequestListFailure());
    yield put(DialogsActions.setClose());
  }
}

function* shipmentByLineRequestList({
  payload,
}: ReturnType<typeof reportsActions.shipmentByLineRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.shipmentByLineRequestList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.shipmentByLineSuccess({
          shipmentLineEntries: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - shipmentByLine - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.shipmentByLineFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getTransportedPassengers({
  payload,
}: ReturnType<typeof reportsActions.getTransportedPassengersRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.transportedPassengersReport, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getTransportedPassengersSuccess({
          transportedPassengersList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - transportedPassengers - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getTransportedPassengersFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getKmDrivedReport({
  payload,
}: ReturnType<typeof reportsActions.getKmDrivedReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportDurableList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getKmDrivedReportSuccess({
          kmDrivedList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - getKmDrivedReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getKmDrivedReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getGateEntryReport({
  payload,
}: ReturnType<typeof reportsActions.getGateEntryReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getGateEntryReportSuccess({
          gateEntryReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - getKmDrivedReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getGateEntryReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* carLIstReport({
  payload,
}: ReturnType<typeof reportsActions.carListReportRequest>): any {
  try {
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.carListReportSuccess({
          carList: response.data,
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - carListReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.carListReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getPassengersByOriginReport({
  payload,
}: ReturnType<typeof reportsActions.getPassengersByOriginReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.getPassengersByOriginReportSuccess({
          passengersByOriginReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - getKmDrivedReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.getPassengersByOriginReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* incomingByKmValueReport({
  payload,
}: ReturnType<typeof reportsActions.incomingByKmValueReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.incomingByKmValueReportSuccess({
          incomingByKmValueList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - incomingByKmValueReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.incomingByKmValueReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* tripCollectionReport({
  payload,
}: ReturnType<typeof reportsActions.tripCollectionReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.tripCollectionReportSuccess({
          tripeCollectionReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - tripCollectionReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.tripCollectionReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* emvReport({
  payload,
}: ReturnType<typeof reportsActions.emvReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.emvReportSuccess({
          emvReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
      yield put(DialogsActions.setSecondClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emvReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.emvReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* bpeReport({
  payload,
}: ReturnType<typeof reportsActions.bpeReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.bpeReportSuccess({
          bpeReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
      yield put(DialogsActions.setSecondClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - bpeReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.bpeReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* bpeTaxVerificationReport({
  payload,
}: ReturnType<typeof reportsActions.bpeTaxVerificationReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.bpeTaxVerificationReportSuccess({
          bpeTaxVerificationReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
      yield put(DialogsActions.setSecondClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - bpeTaxVerificationReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.bpeTaxVerificationReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* gratuitiesReport({
  payload,
}: ReturnType<typeof reportsActions.gratuitiesReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.gratuitiesReportSuccess({
          gratuitiesReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
      yield put(DialogsActions.setSecondClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - gratuitiesReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.gratuitiesReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* emvDeclinedByReasonReport({
  payload,
}: ReturnType<typeof reportsActions.emvDeclinedByReasonReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.emvDeclinedByReasonReportSuccess({
          emvDeclinedByReasonReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emvReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.emvDeclinedByReasonReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* emvApprovedByBrandReport({
  payload,
}: ReturnType<typeof reportsActions.emvApprovedByBrandReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.emvApprovedByBrandReportSuccess({
          emvApprovedByBrandReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emvReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.emvApprovedByBrandReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* emvApprovedByDebtRecoveryReport({
  payload,
}: ReturnType<
  typeof reportsActions.emvApprovedByDebtRecoveryReportRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.emvApprovedByDebtRecoveryReportSuccess({
          emvApprovedByDebtRecoveryReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emvReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.emvApprovedByDebtRecoveryReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* emvApprovedByAttemptsReport({
  payload,
}: ReturnType<typeof reportsActions.emvApprovedByAttemptsReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.emvApprovedByAttemptsReportSuccess({
          emvApprovedByAttemptsReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emvReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.emvApprovedByAttemptsReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* emvApprovedByFirstTapByBrandReport({
  payload,
}: ReturnType<
  typeof reportsActions.emvApprovedByFirstTapByBrandReportRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.emvApprovedByFirstTapByBrandReportSuccess({
          emvApprovedByFirstTapByBrandReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emvReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.emvApprovedByFirstTapByBrandReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* emvEntryGetReport({
  payload,
}: ReturnType<typeof reportsActions.emvEntryGetRequest>): any {
  try {
    const { body } = payload;
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.emvEntryGet, {
      params: { transportOperatorId: transportOperator.id, ...body },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.emvEntryGetSuccess({
          emvEntryGetList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emvEntryGetReport - error', error);
    const { isBalance } = payload;
    if (!isBalance) {
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'error',
          message,
        }),
      );
    }
    yield put(reportsActions.emvEntryGetFailure());
    yield put(DialogsActions.setClose());
  }
}

function* emvEntryGetHistoryReport({
  payload,
}: ReturnType<typeof reportsActions.emvEntryGetHistoryRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.emvEntryGetHistory, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.emvEntryGetHistorySuccess({
          emvEntryGetHistoryList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emvEntryGetHistoryReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.emvEntryGetHistoryFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getOrdersBySchoolReport({
  payload,
}: ReturnType<typeof reportsActions.ordersBySchoolReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.ordersBySchool, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.ordersBySchoolReportSuccess({
          ordersBySchoolsList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - ordersBySchoolReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.ordersBySchoolReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getStudentCardsList({
  payload,
}: ReturnType<typeof reportsActions.studentCardsReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.studentsCardList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.studentCardsReportSuccess({
          studentCardsList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - ordersBySchoolReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.studentCardsReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* gratuitiesReportRequest({
  payload,
}: ReturnType<typeof reportsActions.gratuitiesReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.gratuitiesList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.gratuitiesReportSuccess({
          gratuitiesReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.gratuitiesReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* tripControlDetailsResumeReport({
  payload,
}: ReturnType<
  typeof reportsActions.tripControlDetailsResumeReportRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.tripControlDetailsResumeReportSuccess({
          tripControlDetailsResumeReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - tripControlDetailsResumeReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.tripControlDetailsResumeReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* creditisBySchoolReport({
  payload,
}: ReturnType<typeof reportsActions.creditisBySchoolReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.creditisBySchoolReportSuccess({
          creditisBySchoolReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - profileByAgGroupReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.creditisBySchoolReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* profileByAgGroupReport({
  payload,
}: ReturnType<typeof reportsActions.profileByAgGroupReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.profileByAgGroupReportSuccess({
          profileByAgeGroupList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - profileByAgGroupReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.profileByAgGroupReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* usageStatisticsReport({
  payload,
}: ReturnType<typeof reportsActions.usageStatisticsReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando dados...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.usageStatisticsReportSuccess({
          usageStatisticsReportList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - profileByAgGroupReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.profileByAgGroupReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getTrips({
  payload,
}: ReturnType<typeof reportsActions.getTripsRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Buscando passagens' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(reportsApi.getTrips, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Busca de passagens efetuada com sucesso',
        }),
      );
      yield put(
        reportsActions.tripCollectionReportRequest({
          reportType: REPORTS_TYPES.TRIP_COLLECTION,
          group: (payload as { group: string }).group,
          type: (payload as { type: string }).type,
          startDate: (payload as { startDate: number }).startDate,
          endDate: (payload as { endDate: number }).endDate,
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('getTrips - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(DialogsActions.setClose());
  }
}

function* employeeTripSapResumeReport({
  payload,
}: ReturnType<typeof reportsActions.employeeTripSapResumeReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Seu arquivo será salvo em breve...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        reportsActions.employeeTripSapResumeReportSuccess({
          employeeTripSapResumeReport: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
      yield put(DialogsActions.setSecondClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - emvReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.employeeTripSapResumeReportFailure());
    yield put(DialogsActions.setClose());
  }
}

function* reportDurableClient({
  payload,
  meta,
}: ReturnType<typeof reportsActions.reportDurableClientRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Gerando relatório...',
      }),
    );
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportDurableClient, {
      data: {
        transportOperatorId: transportOperator.id,
        authUserId: transportOperator.SupervisorOperator.id,
        ...payload,
      },
    });

    if (response.status === 200 || response.status === 201) {
      yield put(
        reportsActions.reportDurableClientSuccess({
          id: response.data.id,
        }),
      );

      yield put(DialogsActions.setClose());
      meta?.promise?.resolve(response.data);
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - reportDurableClient - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.reportDurableClientFailure());
    yield put(DialogsActions.setClose());
    meta?.promise?.reject(error);
  }
}

function* reportDurableStatus({
  payload,
}: ReturnType<typeof reportsActions.reportDurableStatusRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Consultando status do relatório...',
      }),
    );

    const response = yield call(reportsApi.reportDurableStatus, {
      params: payload,
    });

    if (response.status === 200 || response.status === 201) {
      yield put(
        reportsActions.reportDurableStatusSuccess({
          durableStatus: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - reportDurableStatus - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.reportDurableStatusFailure());
    yield put(DialogsActions.setClose());
  }
}

function* reportDurableList({
  payload,
}: ReturnType<typeof reportsActions.reportDurableListRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Consultando relatórios assíncronos...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportDurableList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200 || response.status === 201) {
      yield put(
        reportsActions.reportDurableListSuccess({
          durableList: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - reportDurableList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.reportDurableListFailure());
    yield put(DialogsActions.setClose());
  }
}

function* reportDurableCancel({
  payload,
}: ReturnType<typeof reportsActions.reportDurableCancelRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Cancelando requisição...',
      }),
    );
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(reportsApi.reportDurableCancel, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200 || response.status === 201) {
      yield put(
        reportsActions.reportDurableCancelSuccess({
          durableCancel: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - reportDurableCancel - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(reportsActions.reportDurableCancelFailure());
    yield put(DialogsActions.setClose());
  }
}

function* reportDurableDownload({
  payload,
  meta,
}: ReturnType<typeof reportsActions.reportDurableDownloadRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Preparando download do relatório...',
      }),
    );
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(reportsApi.reportDurableDownload, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200 || response.status === 201) {
      if (payload.reportType === REPORTS_TYPES.BPE) {
        yield put(
          reportsActions.bpeReportSuccess({
            bpeReportList: response.data,
          }),
        );
      }

      if (payload.reportType === REPORTS_TYPES.BPE_TAX_VERIFICATION) {
        yield put(
          reportsActions.bpeTaxVerificationReportSuccess({
            bpeTaxVerificationReportList: response.data,
          }),
        );
      }

      yield put(reportsActions.reportDurableDownloadSuccess());

      yield put(DialogsActions.setClose());
      yield put(DialogsActions.setSecondClose());
      meta?.promise?.resolve(response.data);
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('reports - reportDurableDownload - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    if (payload.reportType === REPORTS_TYPES.BPE) {
      yield put(reportsActions.bpeReportFailure());
    }

    if (payload.reportType === REPORTS_TYPES.BPE_TAX_VERIFICATION) {
      yield put(reportsActions.bpeTaxVerificationReportFailure());
    }

    yield put(reportsActions.reportDurableDownloadFailure());
    yield put(DialogsActions.setClose());
    meta?.promise?.reject(error);
  }
}

// eslint-disable-next-line import/prefer-default-export
export const reportsSagas = [
  takeLatest(ReportsTypes.GET_CHART_REPORT_REQUEST, chartValueReport),
  takeLatest(ReportsTypes.GET_INVOICES_LIST_REQUEST, invoicesList),
  takeLatest(ReportsTypes.LINE_DEMAND_REPORT_REQUEST, lineDemandReport),
  takeLatest(ReportsTypes.LINE_QUANTITY_REPORT_REQUEST, lineQuantityReport),
  takeLatest(ReportsTypes.KM_BY_DAY_REPORT_REQUEST, kmPerDayReport),
  takeLatest(
    ReportsTypes.GET_PASSENGERS_AND_VEHICLES_REPORT_REQUEST,
    getPassengersAndVehicles,
  ),
  takeLatest(
    ReportsTypes.GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_REQUEST,
    getPassengersAndVehiclesByTrip,
  ),
  takeLatest(
    ReportsTypes.GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_REQUEST,
    getPedestrianEntryByTerminal,
  ),
  takeLatest(ReportsTypes.DAILY_DEMAND_REPORT_REQUEST, dailyDemandReport),
  takeLatest(
    ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_REQUEST,
    transportedPassengersByTimeFrame,
  ),
  takeLatest(
    ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_REQUEST,
    transportedPassengersByTimeFrameByProfile,
  ),
  takeLatest(ReportsTypes.DAILY_QUANTITY_REPORT_REQUEST, dailyQuantityReport),
  takeLatest(
    ReportsTypes.DAILY_QUANTITY_SECCIONED_REPORT_REQUEST,
    dailyQuantitySeccionedReport,
  ),
  takeLatest(ReportsTypes.GET_CHART_ENTRY_REPORT_REQUEST, chartEntryReport),
  takeLatest(
    ReportsTypes.GET_CHART_ENTRY_REPORT_SIMPLIFIED_REQUEST,
    chartEntryReportSimplified,
  ),
  takeLatest(
    ReportsTypes.GET_SUPERIOR_ACCESS_REPORT_REQUEST,
    superiorAccessReport,
  ),
  takeLatest(ReportsTypes.ENTRY_REPORT_GROUPED_REQUEST, entryReportGrouped),
  takeLatest(ReportsTypes.GET_HEATMAP_REPORT_REQUEST, heatMapReport),
  takeLatest(ReportsTypes.PAYMENT_REPORT_REQUEST, paymentReport),
  takeLatest(ReportsTypes.EMTU_REPORT_REQUEST, EMTUReport),
  takeLatest(ReportsTypes.GENERAL_REPORT_REQUEST, generalReport),
  takeLatest(ReportsTypes.TRAVEL_BY_LINE_REPORT_REQUEST, travelByLineReport),
  takeLatest(ReportsTypes.SHEDULE_LIST_REQUEST, scheduleList),
  takeLatest(ReportsTypes.SECOND_SHEDULE_LIST_REQUEST, secondScheduleList),
  takeLatest(ReportsTypes.SHEDULE_CREATE_REQUEST, scheduleCreate),
  takeLatest(ReportsTypes.SHEDULE_UPDATE_REQUEST, scheduleUpdate),
  takeLatest(ReportsTypes.SHEDULE_DELETE_REQUEST, scheduleDelete),
  takeLatest(ReportsTypes.PAYMENT_REQUEST_LIST_REQUEST, paymentRequestList),
  takeLatest(ReportsTypes.SHIPMENT_BY_LINE_REQUEST, shipmentByLineRequestList),
  takeLatest(
    ReportsTypes.GET_TRANSPORTED_PASSENGERS_REPORT_REQUEST,
    getTransportedPassengers,
  ),
  takeLatest(ReportsTypes.GET_KM_DRIVED_REPORT_REQUEST, getKmDrivedReport),
  takeLatest(ReportsTypes.GET_GATE_ENTRY_REPORT_REQUEST, getGateEntryReport),
  takeLatest(
    ReportsTypes.GET_PASSENGERS_BY_ORIGIN_REPORT_REQUEST,
    getPassengersByOriginReport,
  ),
  takeLatest(
    ReportsTypes.INCOMING_BY_KM_VALUE_REPORT_REQUEST,
    incomingByKmValueReport,
  ),
  takeLatest(ReportsTypes.TRIP_COLLECTION_REPORT_REQUEST, tripCollectionReport),
  takeLatest(ReportsTypes.EMV_REPORT_REQUEST, emvReport),
  takeLatest(
    ReportsTypes.EMV_DECLINED_BY_REASON_REQUEST,
    emvDeclinedByReasonReport,
  ),
  takeLatest(
    ReportsTypes.EMV_APPROVED_BY_BRAND_REQUEST,
    emvApprovedByBrandReport,
  ),
  takeLatest(
    ReportsTypes.EMV_APPROVED_BY_DEBT_RECOVERY_REQUEST,
    emvApprovedByDebtRecoveryReport,
  ),
  takeLatest(
    ReportsTypes.EMV_APPROVED_BY_ATTEMPTS_REQUEST,
    emvApprovedByAttemptsReport,
  ),
  takeLatest(
    ReportsTypes.EMV_APPROVED_FIRST_TAP_BY_BRAND_REQUEST,
    emvApprovedByFirstTapByBrandReport,
  ),
  takeLatest(ReportsTypes.EMV_ENTRY_GET_REQUEST, emvEntryGetReport),
  takeLatest(
    ReportsTypes.EMV_ENTRY_GET_HISTORY_REQUEST,
    emvEntryGetHistoryReport,
  ),
  takeLatest(
    ReportsTypes.ORDERS_BY_SCHOOL_REPORT_REQUEST,
    getOrdersBySchoolReport,
  ),
  takeLatest(ReportsTypes.STUDENT_CARDS_REPORT_REQUEST, getStudentCardsList),
  takeLatest(ReportsTypes.GRATUITIES_REPORT_REQUEST, gratuitiesReportRequest),
  takeLatest(
    ReportsTypes.TRIP_CONTROL_DETAIL_RESUME_REPORT_REQUEST,
    tripControlDetailsResumeReport,
  ),
  takeLatest(
    ReportsTypes.CREDITIS_BY_SCHOOL_REPORT_REQUEST,
    creditisBySchoolReport,
  ),
  takeLatest(
    ReportsTypes.PROFILE_BY_AGE_ROUPE_REPORT_REQUEST,
    profileByAgGroupReport,
  ),
  takeLatest(
    ReportsTypes.USAGE_STATISTICS_REPORT_REQUEST,
    usageStatisticsReport,
  ),
  takeLatest(ReportsTypes.GET_TRIP_REQUEST, getTrips),
  takeLatest(ReportsTypes.LIST_CAR_REPORT_REQUEST, carLIstReport),
  takeLatest(ReportsTypes.LIST_INVOICES_LIST_REQUEST, invoicesListFull),
  takeLatest(ReportsTypes.BPE_REPORT_REQUEST, bpeReport),
  takeLatest(
    ReportsTypes.BPE_TAX_VERIFICATION_REPORT_REQUEST,
    bpeTaxVerificationReport,
  ),
  takeLatest(
    ReportsTypes.EMPLOYEE_TRIP_SAP_RESUME_REPORT_REQUEST,
    employeeTripSapResumeReport,
  ),
  takeLatest(
    ReportsTypes.GET_TIMED_OUT_ENTRIES_REPORT_REQUEST,
    getTimedOutEntries,
  ),
  takeLatest(ReportsTypes.REPORT_DURABLE_CLIENT_REQUEST, reportDurableClient),
  takeLatest(ReportsTypes.REPORT_DURABLE_STATUS_REQUEST, reportDurableStatus),
  takeLatest(ReportsTypes.REPORT_DURABLE_LIST_REQUEST, reportDurableList),
  takeLatest(ReportsTypes.REPORT_DURABLE_CANCEL_REQUEST, reportDurableCancel),
  takeLatest(
    ReportsTypes.REPORT_DURABLE_DOWNLOAD_REQUEST,
    reportDurableDownload,
  ),
];
